// src/features/inspections/InspectionsService.js
import { customFetch } from '../../customFetch';
import { INSPECTIONS, ASSIGNED_TOOLS } from '../../utils/URLS';

const InspectionsService = {
 async getAllInspections() {
   try {
     const response = await customFetch(INSPECTIONS.LIST, {});
     return await response.json();
   } catch (error) {
     console.error('Error en getAllInspections:', error);
     throw error;
   }
 },

 async getInspection(id) {
   try {
     const response = await customFetch(`${INSPECTIONS.LIST}${id}`, {});
     return await response.json();
   } catch (error) {
     console.error(`Error en getInspection (ID: ${id}):`, error);
     throw error;
   }
 },

 async createInspection(inspectionData) {
   try {
     const response = await customFetch(INSPECTIONS.LIST, {
       method: 'POST',
       headers: { 'Content-Type': 'application/json' },
       body: JSON.stringify(inspectionData)
     });

     return await response.json();
   } catch (error) {
     console.error('Error en createInspection:', error);
     throw error;
   }
 },

 // Método específico para crear inspección de persona
 async createPersonInspection(personId, inspectionData) {
   try {
     const response = await customFetch(`${INSPECTIONS.BY_PERSON}${personId}`, {
       method: 'POST',
       headers: { 'Content-Type': 'application/json' },
       body: JSON.stringify(inspectionData)
     });

     return await response.json();
   } catch (error) {
     console.error(`Error en createPersonInspection (PersonID: ${personId}):`, error);
     throw error;
   }
 },
 /**
 * Obtener la lista de responsables de inspecciones disponibles
 * @returns {Promise<string[]>} - Lista de nombres de responsables
 */
async getResponsables() {
  try {
    const response = await customFetch(`${INSPECTIONS.LIST}responsables`, {});
    return await response.json();
  } catch (error) {
    console.error('Error en getResponsables:', error);
    // Devolver un array vacío en caso de error para no romper el formulario
    return [];
  }
},

  // Obtener información de un equipo asignado
   async getAssignedTool(id) {
     try {
       const response = await customFetch(`${ASSIGNED_TOOLS.LIST}${id}`, {});
       const data = await response.json();
       
       if (response.status === 200 || response.status === 201) {
         // Obtener historial del equipo
         const historyResponse = await customFetch(`${ASSIGNED_TOOLS.LIST}${id}/history`, {});
         const historyData = await historyResponse.json();
         
         return {
           statusCode: response.status,
           data: {...data, history: historyData}
         };
       }
       
       return {
         statusCode: response.status,
         data
       };
     } catch (error) {
       console.error(`Error en getAssignedTool (ID: ${id}):`, error);
       throw error;
     }
   },

 // Método específico para crear inspección de herramienta
 async createToolInspection(toolId, inspectionData) {
   try {
     const response = await customFetch(`${INSPECTIONS.BY_TOOL}${toolId}`, {
       method: 'POST',
       headers: { 'Content-Type': 'application/json' },
       body: JSON.stringify(inspectionData)
     });

     return await response.json();
   } catch (error) {
     console.error(`Error en createToolInspection (ToolID: ${toolId}):`, error);
     throw error;
   }
 },

 async updateInspection(id, inspectionData) {
   try {
     const response = await customFetch(`${INSPECTIONS.LIST}${id}`, {
       method: 'PUT',
       headers: { 'Content-Type': 'application/json' },
       body: JSON.stringify(inspectionData)
     });

     return await response.json();
   } catch (error) {
     console.error(`Error en updateInspection (ID: ${id}):`, error);
     throw error;
   }
 },

 async deleteInspection(id) {
   try {
     const response = await customFetch(`${INSPECTIONS.LIST}${id}`, {
       method: 'DELETE'
     });

     return await response.json();
   } catch (error) {
     console.error(`Error en deleteInspection (ID: ${id}):`, error);
     throw error;
   }
 }
};

export default InspectionsService;